/**
 * @generated SignedSource<<18dc11ac1520ace1e6d276182933b9d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type digitalArchiveLinkStyleArticleCheckPathQuery$variables = {
  imageSize: string;
  url: string;
};
export type digitalArchiveLinkStyleArticleCheckPathQuery$data = {
  readonly checkPath: {
    readonly " $fragmentSpreads": FragmentRefs<"digitalArchiveLinkImageUrlPath" | "digitalArchiveLinkTopicUrlPath" | "digitalArchiveLinkUpdatedDateUrlPath">;
  } | null;
};
export type digitalArchiveLinkStyleArticleCheckPathQuery = {
  response: digitalArchiveLinkStyleArticleCheckPathQuery$data;
  variables: digitalArchiveLinkStyleArticleCheckPathQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "imageSize"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "url"
},
v2 = [
  {
    "kind": "Variable",
    "name": "url",
    "variableName": "url"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "kind": "InlineFragment",
  "selections": (v5/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "digitalArchiveLinkStyleArticleCheckPathQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "checkPath",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "digitalArchiveLinkImageUrlPath"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "digitalArchiveLinkUpdatedDateUrlPath"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "digitalArchiveLinkTopicUrlPath"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "digitalArchiveLinkStyleArticleCheckPathQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "checkPath",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "item",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "fields": [
                                  {
                                    "kind": "Variable",
                                    "name": "style",
                                    "variableName": "imageSize"
                                  }
                                ],
                                "kind": "ObjectValue",
                                "name": "filter"
                              }
                            ],
                            "concreteType": "ImageStyle",
                            "kind": "LinkedField",
                            "name": "style",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "updatedDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Topic",
                        "kind": "LinkedField",
                        "name": "topics",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Content",
                    "abstractKey": "__isContent"
                  },
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "Article",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "Gallery",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "Page",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "Podcast",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "Recipe",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "Video",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "UrlPath",
            "abstractKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "634983ee2e6b24ec018ce153148868d3",
    "id": null,
    "metadata": {},
    "name": "digitalArchiveLinkStyleArticleCheckPathQuery",
    "operationKind": "query",
    "text": "query digitalArchiveLinkStyleArticleCheckPathQuery(\n  $url: String!\n  $imageSize: String!\n) {\n  checkPath(url: $url) {\n    __typename\n    ...digitalArchiveLinkImageUrlPath\n    ...digitalArchiveLinkUpdatedDateUrlPath\n    ...digitalArchiveLinkTopicUrlPath\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment digitalArchiveLinkImageUrlPath on UrlPath {\n  item {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      images {\n        title\n        style(filter: {style: $imageSize}) {\n          url\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on Article {\n      id\n    }\n    ... on Gallery {\n      id\n    }\n    ... on Page {\n      id\n    }\n    ... on Podcast {\n      id\n    }\n    ... on Recipe {\n      id\n    }\n    ... on Video {\n      id\n    }\n  }\n}\n\nfragment digitalArchiveLinkTopicUrlPath on UrlPath {\n  item {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      topics {\n        name\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on Article {\n      id\n    }\n    ... on Gallery {\n      id\n    }\n    ... on Page {\n      id\n    }\n    ... on Podcast {\n      id\n    }\n    ... on Recipe {\n      id\n    }\n    ... on Video {\n      id\n    }\n  }\n}\n\nfragment digitalArchiveLinkUpdatedDateUrlPath on UrlPath {\n  item {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      updatedDate\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on Article {\n      id\n    }\n    ... on Gallery {\n      id\n    }\n    ... on Page {\n      id\n    }\n    ... on Podcast {\n      id\n    }\n    ... on Recipe {\n      id\n    }\n    ... on Video {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "147415adb39af02c8efe47e6a2d9b9d7";

export default node;
